import React, { useContext } from 'react';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Context from './Context';

const ShipmentStatus = () => {
  const { values, onChange } = useContext(Context);
  const value = values.shipped ? 'shipped' : 'pending';

  const handleChange = (event, next) => {
    if (!next) {
      return;
    }
    const pending = next === 'pending';
    onChange(
      {
        ...values,
        shipping: pending ? true : null,
        shipped: pending ? null : true
      },
      true
    );
  };

  return (
    <ToggleButtonGroup color="primary" size="small" value={value} exclusive onChange={handleChange}>
      <ToggleButton value="pending">Pending</ToggleButton>
      <ToggleButton value="shipped">Shipped</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ShipmentStatus;
